function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';
import { actions as ppcActions } from '../../reducers/ppc.reducer';
import useEnvArr from '../../helpers/hooks/useEnvArr';
import Table from '../common/table/Table.react';
import Card from '../common/card/Card.react';
import CardHeader from '../common/card/CardHeader.react';
var Testimonials = function Testimonials() {
  var dispatch = useDispatch();
  var navigate = useNavigate();
  var _useParams = useParams(),
    app = _useParams.app;
  var _useSelector = useSelector(function (s) {
      return s.ppc;
    }),
    testimonials = _useSelector.testimonials;
  var _useState = useState(''),
    _useState2 = _slicedToArray(_useState, 2),
    filter = _useState2[0],
    setFilter = _useState2[1];
  var _useState3 = useState({}),
    _useState4 = _slicedToArray(_useState3, 2),
    tableData = _useState4[0],
    setTableData = _useState4[1];
  var cmsEnvironments = useSelector(function (s) {
    return s.settings.constants.environments;
  });
  var envArr = useEnvArr();
  var getPublished = function getPublished(testimonial, environment) {
    // const tmp = Object.values(testimonials).find(x => x.articleID._id === id);
    if (testimonial !== null && testimonial !== void 0 && testimonial.published.find(function (x) {
      return x.clientEnv === environment;
    })) return true;
    return false;
  };
  useEffect(function () {
    dispatch({
      type: ppcActions.testimonials,
      payload: {
        formData: {
          app: app
        }
      }
    });
  }, []);
  useEffect(function () {
    // if (!cmsEnvironments)
    // 	return;

    var data = Object.values(testimonials).filter(function (x) {
      return !x.archived && x.clientApp === app;
    }).map(function (x) {
      var tmpObj = {
        _id: x._id,
        name: x.name,
        email: x.email,
        company: x.company,
        testimonial: x.testimonial
      };
      envArr.forEach(function (env) {
        tmpObj[env] = getPublished(x, env);
      });
      // envArr?.forEach(y => {
      // 	if (envArr.includes(y.value))
      // 		tmpObj[y.value] = getPublished(x, y.value);
      // });

      tmpObj.del = 'Remove';
      return tmpObj;
    });
    var columns = {
      id: {
        title: '_id',
        visible: false
      },
      name: {
        title: 'Name',
        onClick: function onClick(_ref) {
          var row = _ref.row;
          return navigate('/' + app + '/testimonial/' + row._id);
        }
      },
      email: {
        title: 'Email',
        onClick: function onClick(_ref2) {
          var row = _ref2.row;
          return navigate('/' + app + '/testimonial/' + row._id);
        }
      },
      phone: {
        title: 'Phone',
        onClick: function onClick(_ref3) {
          var row = _ref3.row;
          return navigate('/' + app + '/testimonial/' + row._id);
        }
      },
      company: {
        title: 'Company',
        onClick: function onClick(_ref4) {
          var row = _ref4.row;
          return history.push('/' + app + '/testimonial/' + row._id);
        }
      }
    };
    envArr === null || envArr === void 0 ? void 0 : envArr.forEach(function (x) {
      columns[x] = {
        title: x,
        size: 'contain',
        onClick: function onClick(_ref5) {
          var row = _ref5.row,
            key = _ref5.key;
          dispatch({
            type: ppcActions.testimonials,
            payload: {
              formData: {
                testimonialID: row._id,
                env: key,
                isPublished: row[key] ? false : '1970-01-01'
              },
              method: 'put',
              route: 'publish'
            }
          });
        }
      };
    });
    setTableData({
      columns: columns,
      data: data
    });
  }, [testimonials]);
  return /*#__PURE__*/React.createElement("div", {
    className: "page__content"
  }, /*#__PURE__*/React.createElement("div", {
    className: "page__content--block"
  }, /*#__PURE__*/React.createElement(Card, null, /*#__PURE__*/React.createElement(CardHeader, {
    title: "".concat(app, " Testimonials"),
    search: {
      query: filter,
      onChange: function onChange(e) {
        return setFilter(e.target.value);
      },
      label: 'Search Testimonials:',
      placeholder: 'Search...'
    }
  }), /*#__PURE__*/React.createElement(Table, _extends({}, tableData, {
    filter: filter,
    filterColumns: ['name'],
    sort: {
      by: 'name'
    }
  })))));
};
export default Testimonials;